/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Schema_NoteInputs */

const en_directory_submit_content_schema_note = /** @type {(inputs: Directory_Submit_Content_Schema_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual entry, AI Autofill, and Agent-assisted submission all write to the same listing fields. Platform assessments are added after you submit.`)
};

const zh_directory_submit_content_schema_note = /** @type {(inputs: Directory_Submit_Content_Schema_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动填写、AI 自动填写和 Agent 辅助提交都会写入同一份收录字段。平台评分会在你提交后自动生成。`)
};

/**
* | output |
* | --- |
* | "Manual entry, AI Autofill, and Agent-assisted submission all write to the same listing fields. Platform assessments are added after you submit." |
*
* @param {Directory_Submit_Content_Schema_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_schema_note = /** @type {((inputs?: Directory_Submit_Content_Schema_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Schema_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_schema_note(inputs)
	return zh_directory_submit_content_schema_note(inputs)
});
export { directory_submit_content_schema_note as "directory.submit.content.schema_note" }